// extracted by mini-css-extract-plugin
export default {"Chat":"chatHistory_Chat__C43Fh"};